export const BELTONE_MICHIGAN_DEALER_HASH = 'f57e0c68a57db193da71aadd138945e66c210c0a7955f8a8b85afd3846d73a9d';

export const isBeltoneMichiganDealer = (dealerId) => dealerId === BELTONE_MICHIGAN_DEALER_HASH;
